var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import useSurveyNavigatorAnswer from 'apollo/mutations/SURVEY_NAVIGATOR_ANSWER';
import EditableField from './EditableField';
import { EditWrap } from '../styled';
var EditQuestion = function (_a) {
    var question = _a.question, userId = _a.userId, ticketId = _a.ticketId, isTicketSurvey = _a.isTicketSurvey, onAnswerChange = _a.onAnswerChange;
    var onSurveyNavigatorAnswer = useSurveyNavigatorAnswer().onSurveyNavigatorAnswer;
    var setEditValue = useCallback(function (value) {
        if (!value)
            return;
        return onAnswerChange
            ? onAnswerChange(question === null || question === void 0 ? void 0 : question.id, value)
            : onSurveyNavigatorAnswer(__assign(__assign(__assign({ question_id: question === null || question === void 0 ? void 0 : question.id }, (userId && { user_id: userId })), (ticketId && { ticket_id: ticketId })), { answers: value }));
    }, [question === null || question === void 0 ? void 0 : question.id, userId, ticketId, onAnswerChange]);
    return (_jsx(EditWrap, { children: _jsx(EditableField, { question: question, setEditValue: setEditValue, isTicketSurvey: isTicketSurvey }) }));
};
export default EditQuestion;
